/**
 * PDM — Product Bundles (Swiper Slider)
 * --------------------------------------
 * What it does:
 *  - Turns the Product Bundles cards into a Swiper carousel.
 *  - On mobile (< 769px):
 *      • Displays 1 card per slide.
 *      • Enables pagination dots.
 *      • Allows touch swipe and horizontal scrolling.
 *  - On desktop (>= 769px):
 *      • Displays multiple cards at once.
 *      • Disables manual touch movement.
 *      • Keeps consistent spacing between cards.
 *
 * How it works:
 *  - Waits for `DOMContentLoaded` to ensure the DOM is ready.
 *  - Selects ALL instances of `.pdm-product-bundles__swiper`.
 *  - Initializes one Swiper instance per slider found.
 *  - Uses responsive breakpoints to switch behaviors
 *    between mobile and desktop.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  const el = document.querySelector('.pdm-product-bundles__swiper');
  if (!el) return;

  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,       
        spaceBetween: 32,
        centeredSlides: false,
        centerInsufficientSlides: true,
        allowTouchMove: false
      }
    }
  });
});